import { createRootRouteWithContext, HeadContent, Outlet } from '@tanstack/react-router'

import { LoadingRoute } from '@/components/block/common/loading-screen'
import { DialogCallable } from '@/components/ui/dialog-callable'
import { Toaster } from '@/components/ui/sonner'
import { ToastProvider } from '@/components/ui/toast'
import { TooltipProvider } from '@/components/ui/tooltip'

import { hydrate } from '@/lib/auth'
import type { RouteContext } from '@/lib/tanstack-router'

export const Route = createRootRouteWithContext<RouteContext>()({
  beforeLoad: async ({ preload }) => {
    if (preload) return
    await hydrate()
  },
  component: Component,
  pendingComponent: LoadingRoute,
})

function Component() {
  return (
    <TooltipProvider>
      <ToastProvider position='top-center'>
        <HeadContent />
        <Toaster position='top-center' />
        <Outlet />
        <DialogCallable.Root />
      </ToastProvider>
    </TooltipProvider>
  )
}
